import { create } from "zustand";

const useGlobalStore = create((set) => ({
  device: null,
  hasVipAddOn: false,
  currentView: null,
  showBottomBar: true,
  showParkChange: false,
  showRideChange: false,
  showSettings: false,
  showVipSelector: false,
  selectedVipDoor: null,
  settingsInitialView: "all",
  beaconShowPlaying: false,
  hasBeaconAddOn: false,

  setDevice: (value) => set({ device: value }),
  setHasVipAddOn: (value) => set({ hasVipAddOn: value }),
  setHasBeaconAddOn: (value) => set({ hasBeaconAddOn: value }),
  setCurrentView: (value) => set({ currentView: value }),
  setShowBottomBar: (value) => set({ showBottomBar: value }),
  setShowParkChange: (value) => set({ showParkChange: value }),
  setShowRideChange: (value) => set({ showRideChange: value }),
  setShowSettings: (value) => set({ showSettings: value }),
  setShowVipSelector: (value) => set({ showVipSelector: value }),
  setSelectedVipDoor: (value) => set({ selectedVipDoor: value }),
  setSettingsInitialView: (value) => set({ settingsInitialView: value }),
  setBeaconShowPlaying: (value) => set({ beaconShowPlaying: value }),

  resetVip: () =>
    set({
      hasVipAddOn: false,
      currentView: null,
      showBottomBar: true,
      selectedVipDoor: null,
    }),
}));

export default useGlobalStore;
